import { ComponentBase } from 'utils/abstract-classes/component-base'
import { CLASS_NAME } from 'constants/class-names'
import { EventType } from 'constants/enums'

export class ModelPage extends ComponentBase {
    private readonly make: string
    private readonly model: string

    public constructor(wrapper: HTMLElement) {
        super()

        const vehicleData = wrapper

        if (!vehicleData || !vehicleData.dataset) {
            return
        }

        const make = vehicleData.dataset.make

        if (!make) {
            return
        }
        this.make = make

        const model = vehicleData.dataset.model

        if (!model) {
            return
        }
        this.model = model

        const vehicleTrimSelectors = this.getElements<HTMLSelectElement>(
            `.${CLASS_NAME.modelPage.trimSelect}`
        )

        if (vehicleTrimSelectors.length === 0) {
            return
        }

        vehicleTrimSelectors.forEach((element) => {
            element.addEventListener(EventType.CHANGE, () =>
                this.navigateByTrimSelection(
                    this.getSelectedTrim(element.selectedOptions)
                )
            )
        })
    }

    private getSelectedTrim(selectOptions: HTMLCollection): string {
        let trim = '-'
        if (selectOptions.length) {
            trim = (<HTMLInputElement>selectOptions[0]).value
        }
        return trim !== '-' ? trim : ''
    }

    private navigateByTrimSelection(trim: string): void {
        // get url
        const url: URL = new URL(window.location.href)
        // update pathname to include newly selected trim
        if (trim === '') {
            url.pathname = `/${this.make}/${this.model}`
        } else {
            url.pathname = `/${this.make}/${this.model}/${trim}`
        }
        // reload new url
        window.location.assign(url.toString())
    }
}
